import React from "react";
import { Box, Pagination, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const DisabledPagination = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Disabled Pagination
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={
            "disabled pagination in circular and rounder shape and text and outlined variant."
          }
          value={
            "                    <Pagination count={10} disabled/>\n" +
            '                        <Pagination count={10} shape={"rounded"} disabled/>\n' +
            '                        <Pagination count={10} variant={"outlined"} disabled/>\n' +
            '                        <Pagination count={10} shape={"rounded"} variant={"outlined"} disabled/>'
          }
        >
          <Stack spacing={2}>
            <Pagination count={10} disabled />
            <Pagination count={10} shape={"rounded"} disabled />
            <Pagination count={10} variant={"outlined"} disabled />
            <Pagination
              count={10}
              shape={"rounded"}
              variant={"outlined"}
              disabled
            />
          </Stack>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default DisabledPagination;
